import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "backdrop" }
const _hoisted_2 = {
  ref: "modal",
  class: "container"
}
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "title-content"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        ($props.title !== '' || $props.subTitle !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              ($props.title)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString($props.title), 1))
                : _createCommentVNode("", true),
              ($props.subTitle)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.subTitle), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'times'],
          class: "close-icon",
          onClick: $setup.closeModal
        }, null, 8, ["onClick"]),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ], 512)
  ]))
}